import Immutable from "immutable";

const modalResponseDetailsMap = Immutable.Map({
  query: ""
});

export const modalResponseDetails = (state = modalResponseDetailsMap, action) => {
  switch (action.type) {
    case "SET_MODAL_RESPONSE_DETAILS":
      return state.merge(action.payload);
    case "CREATE_TAG_SUCCESS":
    case "ADD_TAG_TO_RESPONSE":
      return state.set("query", "");
    default:
      return state;
  }
};
